import { PermissionsEnum } from "@/auth/interfaces";
import { EstadosPreagendamientoEnumChoice, ModulosEnumChoice, TABLE_CONSTANTS } from "@/shared";
import { useFetchPreagendamientos } from "@/shared/actions/erp";
import { GeneralTable } from "@/shared/components/ui";
import { IDataBitacoraRespById, IPreagendamiento } from "@/shared/interfaces";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useCheckPermissions, useTableColumnsPreagendamientoVentas, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useEffect } from "react";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import CustomSearchFilterSupervisorVenta from "../../../prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";
import ModalMotivoRechazo from "@/shared/components/ui/ModalMotivoRechazo/ModalMotivoRechazo";
import { useModalMotivoRechazo } from "@/shared/components/ui/ModalMotivoRechazo/useModalMotivoRechazo";
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import useEstadoInstalacionSofnet from "@/shared/hooks/useEstadoInstalacionSofnet";
interface AgendaTablaComponenteProps {
  estado_preagendamiento: EstadosPreagendamientoEnumChoice
}

const PreAgendamientoTablaComponente = ({
  estado_preagendamiento
}: AgendaTablaComponenteProps) => {

  useCheckPermissions(PermissionsEnum.api_view_preagendamiento);

  const {
    emitGetVentaById,
    //openCreaBitacora,
    setOpenCreaBitacora,
    setDetalle,
    setFaseVenta,
    setOpen,
    socket,
  } = useDiccionarioMotivo()

  ///* Hook
  const {
    columnaPreagendamiento
  } = useTableColumnsPreagendamientoVentas({
    estado_preagendamiento: estado_preagendamiento
  })

  const useHookModalMotivoRechazo = useModalMotivoRechazo({
    modulo: ModulosEnumChoice.PREAGENDAMIENTO
  })

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,
    vendedor,
    setVendedor

  } = useTableFilter();

  useEffect(() => {
    try {
      setFaseVenta(ModulosEnumChoice.PREAGENDAMIENTO)
    } catch (error) {
      console.log('Error inicializacion el stocket', error)
    }
  }, []);

  const {
    handleValidacion
  } = useEstadoInstalacionSofnet()

  const { pageIndex, pageSize } = pagination;


  ///* React Query

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { isLoading, data: agendaRes,
    isRefetching, } = useFetchPreagendamientos(
      {
        enabled: true,
        params: {
          estado_preagendamiento_in:
            estado_preagendamiento === EstadosPreagendamientoEnumChoice.EN_ESPERA ?
              `${EstadosPreagendamientoEnumChoice.EN_ESPERA},${EstadosPreagendamientoEnumChoice.EN_PAUSA}`
              : estado_preagendamiento
          ,
          identificacion: searchTerm,
          page: pageIndex + 1,
          page_size: pageSize,
          fecha_creacion_after: dateAfter,
          fecha_creacion_before: dateBefore,
          user_create: vendedor,
          ...filterObject,
          filterByState: false
        }
      }
    );


  return (
    <>
      <Grid container spacing={2} >

        <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
            setVendedor={setVendedor}
          //vendedor={vendedor}

          />
        </Grid>


        <Grid item xs={12}>
          <GeneralTable<IPreagendamiento>
            columns={columnaPreagendamiento}
            data={agendaRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={agendaRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            canEdit={false}
            showCustomActionBtnSpace={true}
            enableColumnActions={true} /// 
            enableEditing={true}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
            customActionBtnSpace={(value) => {
              //console.log(value)
              const respData = agendaRes?.data.data.find(item => item.id_preagendamiento === value.id_preagendamiento);
              return (
                <Grid container>
                  {(respData?.preventa_data.estado_aceptacion || respData?.preventa_data.requiere_contrato_fisico) && ( // Verifica si aceptacion es true
                    <Grid item>
                      <Tooltip title={'Crear Bitácora'} placement="top">
                        <IconButton
                          //onClick={()=>setOpenCreaBitacora(true)}
                          onClick={() => {
                            {
                              if (!socket) return;

                              socket.emit('getVentaById', ({
                                numero_referencia_venta: value.id_preagendamiento
                              }), (data: IDataBitacoraRespById) => {

                                if (data.code == 200) {
                                  emitGetVentaById(value.id_preagendamiento!)
                                  setOpen(true)
                                  return
                                }

                                const detail = {
                                  numero_referencia_venta: value.id_preagendamiento,
                                  identificacion_cliente: value.prospecto_data.identificacion || '',
                                  nombre_cliente: value.prospecto_data.razon_social || '',
                                  canal_venta: value.prospecto_data.canal_venta_create || '',
                                  vendedor: value.prospecto_data.user_create,
                                  fecha_aceptacion: value.preventa_data.fecha_aceptacion
                                };
                                setDetalle(detail)
                                setOpenCreaBitacora(true)
                                return
                              })
                            }
                          }}
                        >
                          <ForumRoundedIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  )}


                  <Grid item>
                    <Tooltip title={'Cancelar'} placement="top">
                      <IconButton
                        onClick={async () => {

                          ///* validar

                          const aux = await handleValidacion(value.id_instalacion_externa);

                          if (aux) return;

                          useHookModalMotivoRechazo.setDialogContentText(`Estás a punto de cancelar un Preagendamiento del cliente ${value.prospecto_data.razon_social} con identificación ${value.prospecto_data.identificacion}. ¿Estás seguro? Este cambio es irreversible.`)
                          useHookModalMotivoRechazo.setModalCancelar(true)
                          useHookModalMotivoRechazo.reset({
                            id: value.id_preagendamiento,
                            identificacion: value.prospecto_data.identificacion,
                            razon_social: value.prospecto_data.razon_social,
                            observaciones: value.observaciones
                          })
                        }
                        }
                      >
                        <HighlightOffIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                </Grid>
              )
            }}
          />
        </Grid>
      </Grid >


      {/*Modal para cancelar*/}

      <ModalMotivoRechazo
        {...useHookModalMotivoRechazo}
      />

    </>
  );

}

export default PreAgendamientoTablaComponente;